import { SERVICE_URL } from '@/services/config';
import {
  checkLoggedIn,
  getClinicIntelligenceDemoJWTToken,
  jwtLogin,
} from '@/utils/qlikUtils';
import { Col, Row } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React, { useCallback, useEffect, useState } from 'react';
import { Step, StepSpin } from '../Trial/components/StepSpin';
import './index.css';

type ClinicIntelligenceTrialProps = {};

export const ClinicIntelligenceTrial: React.FC<ClinicIntelligenceTrialProps> = ({}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { xs } = useBreakpoint();
  const [steps, setSteps] = useState<Step[]>([]);
  const [error, setError] = useState<string>();

  const doTheStep = useCallback((step: Step) => {
    setSteps((curr) => [...curr, step]);
  }, []);

  const onFinish = useCallback(async () => {
    try {
      setLoading(true);
      doTheStep('Getting access for you ...');
      const tokenRes = await (
        await getClinicIntelligenceDemoJWTToken(
          `${SERVICE_URL}/trial/clinicintelligencetoken`
        )
      ).json();
      const { token, tenant, region, redirectUrl, webintegrationid } = tokenRes;

      doTheStep('Checking login status ...');
      const loggedIn = await checkLoggedIn(tenant, region, webintegrationid);

      if (loggedIn.status !== 200) {
        doTheStep('Logining to the platform ...');
        const loginRes = await jwtLogin(
          tenant,
          region,
          webintegrationid,
          token
        );
        if (loginRes.status != 200) {
          const message = 'Something went wrong while logging in.';
          throw new Error(message);
        }
        const recheckLoggedIn = await checkLoggedIn(
          tenant,
          region,
          webintegrationid
        );
        if (recheckLoggedIn.status !== 200) {
          const message =
            'Third-party cookies are not enabled in your browser settings and/or browser mode.';
          throw new Error(message);
        }
      }
      doTheStep('Well Done!');
      doTheStep('Refreshing go to platform ...');
      setTimeout(() => {
        window.open(redirectUrl, '_self');
      }, 1000);
    } catch (error: any) {
      if (error?.message) {
        setError(error?.message);
      } else {
        setError(error?.data?.message);
      }
    }
  }, [doTheStep, setLoading, setError]);

  useEffect(() => {
    onFinish();
  }, [onFinish]);

  return (
    <StepSpin
      show={loading}
      steps={steps}
      error={error}
      onClose={() => {
        setLoading(false);
        setError(undefined);
        setSteps([]);
      }}
    >
      <div className="trialContainer">
        <div className="trialWrapper">
          <Row
            className="trialContainerRow"
            style={{ height: xs ? '100%' : 'auto' }}
          >
            <Col xs={24} sm={12}>
              <div className="trialTitleWrapper">
                <div className="trialTitleLarge">
                  Take ExtendBI™ for a Test Drive Today!
                </div>
                <div className="trialTitleRegular">
                  Easy to use Qlik extensions. No need to call IT.
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </StepSpin>
  );
};
